import React, { useState, useEffect } from "react";
import Footer from "../../../components/footerPage/Footer";
import AllHeader from "../../../components/Navbar/AllHeader";
import BodyDestination from "./components/BodyDestination";
import Sail from "../../../Asset/image/yacht/Sail.gif"; // loader gif
import SEO from "../../../components/SEO/SEO";

function Destination() {
  const [loading, setLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // จำลองการโหลดข้อมูล
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // 2 วินาทีหรือจะปรับตามต้องการ

    return () => clearTimeout(timer);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <SEO
        title={
          selectedLanguage === "en"
            ? "Destinations | Take My Yacht"
            : "จุดหมายปลายทาง | Take My Yacht"
        }
        description={
          selectedLanguage === "en"
            ? "Explore top yacht charter destinations across Thailand with Take My Yacht. Discover premium routes and private charter experiences."
            : "สำรวจจุดหมายปลายทางยอดนิยมสำหรับการเช่าเรือยอชต์ทั่วประเทศไทย พร้อมเส้นทางระดับพรีเมียมและประสบการณ์เหมาลำส่วนตัว"
        }
        url="https://takemyyacht.com/destination"
        schema={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          name:
            selectedLanguage === "en"
              ? "Destinations - Take My Yacht"
              : "จุดหมายปลายทาง - Take My Yacht",
          url: "https://takemyyacht.com/destination",
          description:
            selectedLanguage === "en"
              ? "Explore popular yacht charter destinations across Thailand with premium private charter experiences."
              : "รวมจุดหมายปลายทางยอดนิยมสำหรับการเช่าเรือยอชต์ทั่วประเทศไทย พร้อมประสบการณ์เหมาลำระดับพรีเมียม",
        }}
      />

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={Sail}
            alt="Loading..."
            style={{
              width: 300,
              height: 300,
              objectFit: "contain",
              borderRadius: "12px",
            }}
            draggable={false}
          />
        </div>
      )}

      <div style={{ opacity: loading ? 0.5 : 1 }}>
        <AllHeader />
        <BodyDestination />
        <Footer />
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#3291B6", // สีเดิม
            color: "#fff",
            cursor: "pointer",
            boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.25s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default Destination;
